<template>
  <h1 class="section-title" :class="{ 'is-white': white }">
    <slot />
  </h1>
</template>

<script>
export default {
  name: 'SectionTitle',

  props: {
    white: Boolean,
  },
};
</script>

<style lang="scss" scoped>
h1 {
  position: relative;
  font-weight: 400;
  margin: 0;
  margin-bottom: 30px;
  color: $--color--primary;
  @include font-size(50px);

  &.is-white {
    color: #fff;
  }
}
</style>
